/**
 * Demo progressive navigation — unlock Clients (Settings) before the first project exists.
 */
import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useActiveProject } from '../context/ActiveProjectContext';
import { useCompanyProjects } from '../context/CompanyProjectsContext';
import { useDemoStatus } from './useConfigQueries';

export function useProgressiveNavContext() {
  const { token } = useAuth();
  const { activeProject } = useActiveProject();
  const { hasProjects, projectsLoaded } = useCompanyProjects();
  const { data: demoStatusRaw } = useDemoStatus({ enabled: !!token });

  const demoStatus = useMemo(
    () => (demoStatusRaw?.is_demo ? demoStatusRaw : null),
    [demoStatusRaw],
  );

  const isDemoProjectBootstrap =
    Boolean(demoStatus?.is_demo) &&
    projectsLoaded &&
    !hasProjects &&
    !activeProject;

  return {
    isDemo: Boolean(demoStatus?.is_demo),
    isDemoProjectBootstrap,
    demoStatus,
  };
}
